// extracted by mini-css-extract-plugin
export default {"component":"GuidesSection__component-dkrY","sectionTitle":"GuidesSection__sectionTitle-ATeK"};